import NewAppLayout from "@/components/layout/NewAppLayout";

const DiscoverPage = () => {
  return (
    <NewAppLayout pageTitle="Discover">
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-slate-900 mb-2">Discover</h1>
          <p className="text-slate-600">Coming soon...</p>
        </div>
      </div>
    </NewAppLayout>
  );
};

export default DiscoverPage;
